import { Component, inject } from '@angular/core';
import { Messaging } from '@angular/fire/messaging'
import { DashboardComponent } from '@nx-superprep/pop-ui'

@Component({
    selector: 'popstudy2-popstudy',
    standalone: true,
    templateUrl: './popstudy.component.html',
    styleUrls: [],
    imports: [DashboardComponent]
})
export class PopstudyComponent {
  private readonly messaging = inject(Messaging)
}
